import React from 'react';

function WeekSelector({ currentWeek, selectedWeek, onWeekChange }) {
    // Generate all week options: Regular season (1-18) + Playoffs (19-22)
    const regularSeasonWeeks = Array.from({ length: 18 }, (_, i) => i + 1);
    const playoffWeeks = Array.from({ length: 4 }, (_, i) => i + 19);
    const weeks = [...regularSeasonWeeks, ...playoffWeeks];

    return (
        <div style={{
            backgroundColor: '#4a5568',
            borderRadius: '12px',
            padding: '20px',
            marginBottom: '20px',
            border: '2px solid #2d3748'
        }}>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginBottom: '15px'
            }}>
                <h3 style={{
                    color: '#f7fafc',
                    margin: 0,
                    fontSize: '16px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                }}>
                    <span>📅</span>
                    Select Week
                </h3>
                <div style={{
                    fontSize: '12px',
                    color: '#a0aec0',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '4px'
                }}>
                    <span>🏈</span>
                    Current NFL Week: {currentWeek}
                </div>
            </div>

            <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(60px, 1fr))',
                gap: '10px',
                maxHeight: '200px',
                overflowY: 'auto'
            }}>
                {weeks.map(week => {
                    const isSelected = week === selectedWeek;
                    const isCurrent = week === currentWeek;
                    const isPast = week < currentWeek;
                    const isFuture = week > currentWeek;
                    const isPlayoff = week >= 19;
                    const isRegularSeason = week <= 18;

                    let backgroundColor = '#2d3748';
                    let color = '#a0aec0';
                    let borderColor = '#4a5568';

                    // Enhanced styling for playoff weeks
                    if (isPlayoff) {
                        if (isSelected) {
                            backgroundColor = '#9f7aea'; // Purple for selected playoff
                            color = 'white';
                            borderColor = '#805ad5';
                        } else if (isCurrent) {
                            backgroundColor = '#d69e2e'; // Gold for current playoff
                            color = 'white';
                            borderColor = '#b7791f';
                        } else if (isPast) {
                            backgroundColor = '#718096'; // Gray for past playoff
                            color = '#f7fafc';
                            borderColor = '#4a5568';
                        } else if (isFuture) {
                            backgroundColor = '#f56565'; // Red for future playoff
                            color = 'white';
                            borderColor = '#e53e3e';
                        }
                    } else {
                        // Regular season styling (unchanged)
                        if (isSelected) {
                            backgroundColor = '#4299e1';
                            color = 'white';
                            borderColor = '#3182ce';
                        } else if (isCurrent) {
                            backgroundColor = '#48bb78';
                            color = 'white';
                            borderColor = '#38a169';
                        } else if (isPast) {
                            backgroundColor = '#718096';
                            color = '#f7fafc';
                            borderColor = '#4a5568';
                        } else if (isFuture) {
                            backgroundColor = '#ed8936';
                            color = 'white';
                            borderColor = '#dd6b20';
                        }
                    }

                    return (
                        <button
                            key={week}
                            onClick={() => onWeekChange(week)}
                            style={{
                                padding: '12px 8px',
                                backgroundColor,
                                color,
                                border: `2px solid ${borderColor}`,
                                borderRadius: '8px',
                                fontSize: '14px',
                                fontWeight: 'bold',
                                cursor: 'pointer',
                                transition: 'all 0.2s ease',
                                position: 'relative',
                                minHeight: '44px',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                            onMouseEnter={(e) => {
                                if (!isSelected) {
                                    e.target.style.transform = 'translateY(-2px)';
                                    e.target.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.2)';
                                }
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.transform = 'translateY(0px)';
                                e.target.style.boxShadow = 'none';
                            }}
                        >
                            <div style={{ fontSize: '16px' }}>
                                {week <= 18 ? week : `P${week - 18}`}
                            </div>
                            <div style={{ fontSize: '10px', opacity: 0.8 }}>
                                {isCurrent ? 'LIVE' : isPast ? 'PAST' : isFuture ? 'FUTURE' : ''}
                            </div>
                            <div style={{ fontSize: '9px', opacity: 0.7, marginTop: '2px' }}>
                                {week <= 18 ? 'REG' : 'PLAYOFF'}
                            </div>
                        </button>
                    );
                })}
            </div>

            {/* Week Info */}
            <div style={{
                marginTop: '15px',
                paddingTop: '15px',
                borderTop: '1px solid #2d3748',
                fontSize: '12px',
                color: '#a0aec0'
            }}>
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))',
                    gap: '10px',
                    textAlign: 'center'
                }}>
                    <div>
                        <span style={{ color: '#48bb78' }}>●</span> Current Week
                    </div>
                    <div>
                        <span style={{ color: '#718096' }}>●</span> Past Weeks
                    </div>
                    <div>
                        <span style={{ color: '#ed8936' }}>●</span> Future Weeks
                    </div>
                    <div>
                        <span style={{ color: '#4299e1' }}>●</span> Selected
                    </div>
                </div>
            </div>

            {selectedWeek !== currentWeek && (
                <div style={{
                    marginTop: '10px',
                    padding: '10px',
                    backgroundColor: 'rgba(237, 137, 54, 0.1)',
                    border: '1px solid #ed8936',
                    borderRadius: '6px',
                    fontSize: '12px',
                    color: '#ed8936',
                    textAlign: 'center'
                }}>
                    {selectedWeek < currentWeek 
                        ? `⚠️ You're viewing past week ${selectedWeek}. Some leagues may be completed.`
                        : `🔮 You're viewing future week ${selectedWeek}. Leagues may not be available yet.`
                    }
                </div>
            )}
        </div>
    );
}

export default WeekSelector;